import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-layout',
  templateUrl: './project-layout.component.html',
  styleUrls: ['./project-layout.component.scss'],
  standalone: false,
})
export class ProjectLayoutComponent {}
